import { useShowVersionPanel } from '@atlassian/jira-software-view-settings/src/controllers/index.tsx';
import { useBacklogSelector } from '../index.tsx';
import { isVersionsFeatureEnabled } from '../selectors/version/index.tsx';

export const useIsVersionsPanelOpen: () => boolean = () => {
	const isVersionPanelOpen = useShowVersionPanel();

	const isVersionsEnabled = useBacklogSelector(isVersionsFeatureEnabled);
	return isVersionsEnabled && isVersionPanelOpen;
};
